import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { constBreadCrumbsTitle, createSanitizeCustom } from 'utility';
import { makeStyles } from '@mui/styles';
import { Grid, Typography, Button, Avatar } from '@mui/material';
import { PageContainer, LoadingPage, ButtonLoading, InputV2, Icons } from 'components';
import Services from '../services/Services';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import createToast from 'components/Toast/Toast';
import Link from '@mui/material/Link';
import useCustomHook from '../hooks';
import { useQuery } from 'hooks';
import UploadFiles from 'components/UploadFile';
import { animateScroll as scroll } from 'react-scroll';
const SettlementDetails = (props) => {
  const classes = useStyles();
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const methods = useForm({ defaultValues: { Content: '' } });
  const { ticketId, ticketPId, projectId } = useParams();

  const {
    submitLoading,
    setSubmitLoading,
    setIsLoading,
    data,
    setData,
    status,
    setStatus,
    isLoading,
    creditorStatus,
    setCreditorStatus,
    loadingAgree,
    setLoadingAgree,
    filesUpoaded,
    setFilesUpoaded,
    keyDom, setKeyDom
  } = useCustomHook();
  const query = useQuery();
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const dataTicket = await Services.getRequestInfo(ticketId, projectId);
      setStatus(dataTicket?.result?.RequestStatus);
      const dataDiscussions = await Services.getDiscussions(ticketPId, projectId, {
        offset: 0,
        size: 1000,
        workItemId: ticketId,
      });
      if (dataTicket?.result?.TicketStatus !== 'انجام شده' && dataTicket?.result?.TicketStatus !== "لغو شده") {
        setCreditorStatus(true);
      }
      setData({
        dataTicket: dataTicket?.result,
        dataDiscussions: dataDiscussions?.result,
      });
    } catch (e) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };
  const onSubmit = async (formData) => {
    setSubmitLoading(true);

    if (data.dataTicket?.TicketStatus === 'انجام شده') {
      const res = {
        reason: createSanitizeCustom(formData?.Content, {
          ALLOWED_TAGS: [],
          ALLOWED_ATTR: [],
        })
      };

      await Services.postFailStatus(ticketId, res)
        .then(() => {
          createToast('موفق', 'وضعیت با موفقیت تغییر کرد.', 'success');
          setSubmitLoading(false);
          navigate(-1);
        })
        .catch(() => {
          setSubmitLoading(false);
        });
      methods.reset();
      return;
    } else {
      try {
        const copy = JSON.stringify(formData);
        const copyContent =
          createSanitizeCustom(JSON.parse(copy)?.Content, {
            ALLOWED_TAGS: [],
            ALLOWED_ATTR: [],
          })
        const obj = { "hashCode": filesUpoaded[0]?.hash, "fileName": filesUpoaded[0]?.name }
        let attachFile;
        let dataTicket
        if (filesUpoaded && filesUpoaded.length > 0) {
          attachFile = await Services.attachDiscussion(ticketPId, projectId, ticketId, obj);
          dataTicket = await Services.getRequestInfo(ticketId, projectId);
        }
        const result = await Services.addDiscussion(ticketPId, projectId, ticketId, { Content: copyContent });
        setData({
          ...data,
          dataDiscussions: [result?.data?.result, ...data?.dataDiscussions],
          dataTicket: dataTicket && dataTicket?.result ? dataTicket?.result : data?.dataTicket
        });
        scroll.scrollToTop();
        createToast('موفق', 'با موفقیت ارسال شد.', 'success');
        setFilesUpoaded([]);
        setKeyDom(k => k + 1)
        methods.reset();
      } catch (error) {
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  const bearkString = (str) => {
    if (String(str).length > 20) {
      return ' ... ' + String(str).substring(0, 19);
    } else {
      return str;
    }
  };

  const replaceWithBr = (content) => {
    return createSanitizeCustom(content.replace(/\n/g, '<br />'), {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    });
  };

  const handleButtonClick = (value) => {
    if (value === 'no') {
      setCreditorStatus(true);
    } else {
      setLoadingAgree(true);
      setCreditorStatus(false);
      Services.postApprovalStatus(ticketId)
        .then(() => {
          createToast('موفق', 'وضعیت با موفقیت به بسته شده تغییر کرد.', 'success');
          setLoadingAgree(false);
          navigate(-1);
        })
        .catch(() => {
          setLoadingAgree(false);
        });
    }
  };

  const getKeyBreadCrumbsWithUrl = () => {
    const ticketCat = query?.get('ticketCat');

    if (!ticketCat) return null;

    return ticketCat === 'support'
      ? constBreadCrumbsTitle.TICKET_SUPPORT_DETAILS
      : constBreadCrumbsTitle.TICKET_SALE_DETAILS;
  };
  return (
    <>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <PageContainer
          title={`موضوع درخواست : ${data.dataTicket?.Name || '-'}`}
          meta={
            <Button
              color="primary"
              variant="outlined"
              endIcon={<Icons icon="CaretLeft" color="#2b3990" size="25" />}
              onClick={() => navigate(-1)}
            >
              بازگشت به لیست درخواست ها
            </Button>
          }
          breadcrumbs={getKeyBreadCrumbsWithUrl()}
        >
          {!isError ? (
            <>
              <Grid container className={classes.details}>
                <Grid item xs={12}>
                  وضعیت درخواست : {data.dataTicket?.TicketStatus}
                </Grid>
                <Grid item xs={12}>
                  تاریخ ایجاد : {data.dataTicket?.CreationDatePersian}
                </Grid>
                <Grid item xs={12}>
                  از طرف : {data.dataTicket?.UserInfo?.Name}
                </Grid>
              </Grid>

              <div style={{ margin: '4px', color: '#7a7a7a', marginTop: '12px' }}>
                فایل های پیوست دریافتی:{' '}
              </div>
              <Grid container style={{ marginTop: '12px', maxHeight: '200px', overflowY: 'auto' }}>
                <Grid
                  xs={12}
                  md={6}
                  lg={6}
                  item
                  alignItems="center"
                  spacing={2}
                  className={classes.containerFileUpload}
                >
                  {data.dataTicket?.AttachmentInfo &&
                    data.dataTicket?.AttachmentInfo.length > 0 &&
                    data.dataTicket?.AttachmentInfo.map((item, index) => {
                      return (
                        <Grid md={6} lg={6} xs={12} className={classes.fileLink}>
                          <Link
                            style={{ display: 'flex', alignItems: 'center' }}
                            href={item.link}
                            target="_blank"
                          >
                            <Icons icon="Document" color="#263238" size="25" />
                            {/* مدرک شماره {index + 1} */}
                            {item.FileName ? bearkString(item.FileName) : 'File'}
                          </Link>
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>

              <Grid container className={classes.discussionBox}>
                {/* ============================================================================ */}

                <Grid
                  xs={12}
                  md={12}
                  lg={8}
                  className={clsx(classes.discussionItem, classes.discussionItemResponser)}
                >
                  <Grid style={{ display: 'flex' }}>
                    <Grid item xs="auto">
                      <Avatar
                        alt={data?.dataTicket?.UserInfo.Name}
                        src={data?.dataTicket?.UserInfo.Image}
                        className={classes.avatar}
                      />
                    </Grid>

                    <Grid item xs="auto">
                      <Typography className={classes.discussionItemUserName}>
                        {data?.dataTicket?.UserInfo?.Name}
                      </Typography>
                      <Typography className={classes.discussionItemTime}>
                        زمان ارسال: {data?.dataTicket?.CreationDatePersian}
                      </Typography>
                    </Grid>
                  </Grid>
                  <div
                    className={classes.textJustify}
                    dangerouslySetInnerHTML={{
                      __html: createSanitizeCustom(data.dataTicket?.Description, {
                        ALLOWED_TAGS: [],
                        ALLOWED_ATTR: [],
                      }),
                    }}
                  />
                </Grid>
                {/* ============================================================================ */}

                {data.dataDiscussions &&
                  data.dataDiscussions.map((discussion, index) => (
                    <Grid
                      xs={12}
                      md={12}
                      lg={8}
                      className={clsx(classes.discussionItem, classes.discussionItemResponser)}
                    >
                      <Grid style={{ display: 'flex' }}>
                        <Grid item xs="auto">
                          <Avatar
                            alt={discussion?.OwnerInfo?.Name}
                            src={discussion?.OwnerInfo?.Image}
                            className={classes.avatar}
                          />
                        </Grid>

                        <Grid item xs="auto">
                          <Typography className={classes.discussionItemUserName}>
                            {discussion?.OwnerInfo?.Name}
                          </Typography>
                          <Typography className={classes.discussionItemTime}>
                            زمان ارسال: {discussion?.CreationDatePersian}
                          </Typography>
                        </Grid>
                      </Grid>

                      <div
                        className={classes.textJustify}
                        dangerouslySetInnerHTML={{ __html: replaceWithBr(discussion?.Content) }}
                      />
                    </Grid>
                  ))}
              </Grid>
              {data.dataTicket?.TicketStatus !== 'خاتمه یافته' ? (
                <form onSubmit={methods.handleSubmit(onSubmit)} noValidate autoComplete="off">
                  <Grid container>
                    {creditorStatus ? (
                      <>
                        {data.dataTicket?.TicketStatus === 'CLOSE' ||
                          !data.dataTicket?.TicketStatus ? (
                          <Grid item xs={12}>
                            <Typography style={{ margin: '8px 8px', opacity: '0.5', fontSize: 12 }}>
                              پاسخ خود را بنویسید
                            </Typography>
                            <Grid className={classes.disableForm}></Grid>
                          </Grid>
                        ) : (
                          <Grid item xs={12} md={8} lg={8}>
                            <InputV2
                              multiline
                              fullWidth
                              name="Content"
                              rows={5}
                              errors={methods.formState.errors}
                              register={methods.register}
                              control={methods.control}
                              label="پاسخ"
                              rules={['required', 'isNotHtmlTags']}
                            />

                            <div className={classes.fileUlpload}>
                              <div className={classes.BIBadge}>
                                <Icons icon="Info" color="#667585" size="17" className={classes.BIIcon} />
                                <span>حداکثر تعداد فایل مجاز یک عدد می‌باشد</span>
                              </div>
                              <UploadFiles
                                key={keyDom}
                                tooltip="فرمت فایل ارسالی به صورت jpg ,png ,pdf می‌باشد."
                                hasLink={true}
                                multiple={false}
                                setList={setFilesUpoaded}
                                type={'TICKETING'}
                              />

                            </div>
                          </Grid>
                        )}
                      </>
                    ) : (
                      data.dataTicket?.TicketStatus !== "لغو شده" &&
                      // محتوای برای سایر موارد
                      <Grid item xs={12}>
                        <Typography
                          style={{
                            margin: '8px 8px',
                            fontSize: 14,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          آیا مشکل برطرف شده است؟
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              marginRight: '10px',
                              gap: 10,
                            }}
                          >
                            <ButtonLoading
                              name="بلی"
                              value="yes"
                              variant="contained"
                              color="primary"
                              loading={loadingAgree}
                              disabled={loadingAgree}
                              onClick={() => handleButtonClick('yes')}
                            />
                            <ButtonLoading
                              name="خیر"
                              value="no"
                              variant="contained"
                              color="secondary"
                              onClick={() => handleButtonClick('no')}
                              disabled={loadingAgree}
                            />
                          </div>
                        </Typography>
                      </Grid>
                    )}

                    {/* دکمه ارسال */}
                    {creditorStatus && (
                      <Grid
                        container
                        item
                        xs={12}
                        className={classes.submitButtonWrapper}
                        justifyContent="space-between"
                      >
                        <ButtonLoading
                          type="submit"
                          variant="contained"
                          color="primary"
                          loading={submitLoading}
                          disabled={
                            submitLoading ||
                            status == 'CLOSE' ||
                            !status ||
                            (data.dataTicket?.result?.TicketStatus === 'انجام شده' &&
                              !creditorStatus)
                          }
                          name="ارسال"
                        />
                      </Grid>
                    )}
                  </Grid>
                </form>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
        </PageContainer>
      )}
    </>
  );
};

export default SettlementDetails;

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  headerContent: {
    display: 'inline-block',
    paddingRight: 5,
    paddingLeft: 5,
    color: '#7a7a7a',
  },
  discussionBox: {
    marginTop: 30,
    marginBottom: 20,
    paddingTop: 30,
    borderTop: '1px solid #e1e2e3',
    borderBottom: '1px solid #e1e2e3',
    display: 'flex',
    flexDirection: 'column',
  },
  discussionItem: {
    marginBottom: 30,
  },
  discussionItemResponser: {
    backgroundColor: '#e8efff',
    borderRadius: 5,
    padding: 15,
  },
  avatar: {
    marginRight: 10,
  },
  discussionItemUserName: {
    marginTop: 10,
    fontSize: 13,
  },
  discussionItemTime: {
    marginTop: 2,
    marginBottom: 20,
    color: '#868b8f',
    fontSize: 12,
  },
  submitButtonWrapper: {
    marginTop: 20,
    flexDirection: 'row-reverse',
  },

  containerFileUpload: {
    display: 'flex',
    'flex-wrap': 'wrap',
  },
  disableForm: {
    opacity: 0.5,

    backgroundColor: '#eaeaea',
    borderRadius: '4px',
    cursor: 'not-allowed',
    height: '120px',
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
  opacityHide: {
    opacity: 0.5,
  },
  details: {
    display: 'flex',
    color: '#7a7a7a',
    '& > div': {
      margin: '4px',
    },
    marginTop: '-20px',
  },
  textJustify: {
    wordBreak: 'break-word',
    textAlign: 'justify',
  },

  BIBadge: {
    background: theme.palette.grey[200],
    color: theme.palette.grey[600],
    fontSize: 12,
    padding: '3px 9px 4px 4px',
    marginInlineStart: theme.spacing(1),
    display: 'inline-flex',
    borderRadius: 20,
    gap: 4,
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'ease color .25s,ease background .25s',
    '@media(max-width: 550px)': {
      padding: '3px 5px',
      '& span': {
        fontSize: 11,
      },
    },
  },
  BIIcon: {
    fontSize: 15,
    marginBottom: theme.spacing(-0.5),
    marginInlineEnd: theme.spacing(1),
  },
}));
